import React from "react";
import { Checkbox } from "@mui/material";

export default function CheckboxInput({ ...props }) {
  return <Checkbox {...props} label="acc" />;
}
